import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import getPmGraphOptions from '@amplify/pm-graphs-service';
import MeasureDataGrid from './MeasureDataGrid';
import MeasureWithStudentPrintInfo from './MeasureWithStudentPrintInfo';
import { getPageBreakingRowIndex } from '../../../../utils/shared/printUtils';
import { SECTION_IDS } from '../../../../constants/shared/CommonConstants';
import { PM_GRAPH_OPTIONS_TYPE } from '../../../../constants/shared/GraphConstants';
import { getCustomAndDefaultGoalByPeriod } from '../../../../utils/shared/pmGraphUtils';
import PmGraph from './graphs/PmGraph';
import { createDataTourStep } from '../../../../utils/shared/demoModeUtils';

const { SS_PROGRESS_MEASURE_LIST } = SECTION_IDS;

const ProgressContent = ({
    isCurrentSchoolYear,
    studentDataByMeasures,
    openProbeDetails,
    currentPeriod,
    windowDates,
    selectedYear,
    currentSchoolYear,
    student,
    location,
    chartLookerEvent,
    isDataMeasureExists,
    getMeasureTitle,
    CommonCellBuilder,
    isGoalAvailable,
    getSpecificGoal,
    resetZoomLookerEvent,
    toyPeriods,
    summerPeriodLabel,
}) => {
    const { grade, year, dataByMeasure } = studentDataByMeasures;
    return (
        <div id={SS_PROGRESS_MEASURE_LIST} className="measure-list">
            {dataByMeasure.map(
                ({ interps, statuses, goals, measure, isMeasureLicensedInGrade = true }, index) => {
                    const isFirstMeasure = index === 0;
                    const graphOptions = getPmGraphOptions(
                        interps,
                        statuses,
                        goals,
                        grade,
                        currentPeriod,
                        windowDates,
                        selectedYear,
                        currentSchoolYear,
                        isCurrentSchoolYear,
                        measure,
                        PM_GRAPH_OPTIONS_TYPE.SS_PROGRESS,
                        chartLookerEvent,
                        resetZoomLookerEvent,
                    );
                    const customAndDefaultGoalByPeriod = getCustomAndDefaultGoalByPeriod(
                        interps,
                        goals,
                        statuses,
                        currentPeriod,
                        toyPeriods,
                    );

                    const isGraphExists = !isEmpty(graphOptions) && isMeasureLicensedInGrade;
                    return (
                        isDataMeasureExists(statuses, measure) && (
                            <div
                                key={measure}
                                data-tour-step={createDataTourStep(measure)}
                                className={`measure-data ${isFirstMeasure ? 'first-measure' : ''}`}
                            >
                                <MeasureWithStudentPrintInfo
                                    student={student}
                                    measure={measure}
                                    grade={grade}
                                    getMeasureTitle={getMeasureTitle}
                                />
                                {isGraphExists && (
                                    <PmGraph
                                        isCurrentSchoolYear={isCurrentSchoolYear}
                                        customAndDefaultGoalByPeriod={customAndDefaultGoalByPeriod}
                                        graphOptions={graphOptions}
                                        graphKey={`${measure}-${grade}-${year}`}
                                    />
                                )}
                                <MeasureDataGrid
                                    statuses={statuses}
                                    interps={interps}
                                    openProbeDetails={openProbeDetails}
                                    pageBreakingRowIndex={getPageBreakingRowIndex(
                                        isGraphExists,
                                        isFirstMeasure,
                                    )}
                                    location={location}
                                    measure={measure}
                                    grade={grade}
                                    student={student}
                                    getMeasureTitle={getMeasureTitle}
                                    CommonCellBuilder={CommonCellBuilder}
                                    isGoalAvailable={isGoalAvailable}
                                    getSpecificGoal={getSpecificGoal}
                                    summerPeriodLabel={summerPeriodLabel}
                                />
                            </div>
                        )
                    );
                },
            )}
        </div>
    );
};

ProgressContent.defaultProps = {
    isCurrentSchoolYear: true,
    studentDataByMeasures: {},
    currentPeriod: '',
    windowDates: {},
    selectedYear: null,
    currentSchoolYear: null,
    chartLookerEvent: () => {},
    student: {},
    location: {},
    isDataMeasureExists: () => true,
    getMeasureTitle: () => {},
    CommonCellBuilder: () => <></>,
    isGoalAvailable: () => {},
    getSpecificGoal: () => '',
    resetZoomLookerEvent: () => {},
    toyPeriods: [],
};

ProgressContent.propTypes = {
    isCurrentSchoolYear: PropTypes.bool,
    studentDataByMeasures: PropTypes.object,
    student: PropTypes.object,
    location: PropTypes.object,
    currentPeriod: PropTypes.string,
    windowDates: PropTypes.object,
    selectedYear: PropTypes.number,
    currentSchoolYear: PropTypes.number,
    chartLookerEvent: PropTypes.func,
    openProbeDetails: PropTypes.func.isRequired,
    isDataMeasureExists: PropTypes.func,
    getMeasureTitle: PropTypes.func,
    CommonCellBuilder: PropTypes.func,
    isGoalAvailable: PropTypes.func,
    getSpecificGoal: PropTypes.func,
    resetZoomLookerEvent: PropTypes.func,
    toyPeriods: PropTypes.array,
    summerPeriodLabel: PropTypes.string.isRequired,
};

export default ProgressContent;
